import { useRef, ButtonHTMLAttributes, ReactNode } from "react";

import { ButtonContainer, ButtonSpinnerLoading } from "./styles";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  isLoading?: boolean;
}

export default function Button({ children, isLoading = false, ...props }: ButtonProps) {
  const containerRef = useRef<HTMLButtonElement>();

  return (
    <ButtonContainer {...props} ref={containerRef} isLoading={isLoading}>
      {children}
      {isLoading && <ButtonSpinnerLoading />}
    </ButtonContainer>
  );
}
